import {PlayerImageType} from "data/enums";
import React, {useEffect, useState} from "react";
import styled from "@emotion/styled";
import {CircularProgress} from "@mui/material";
import {IPlayer} from "data/stores/players/players.store";
import {
	getPlayerAvatar,
	getPlayerActionShotImage,
	getPlayerActionFullImage,
} from "data/utils/player";

const Position = styled.div`
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	height: 100%;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	span {
		opacity: 0.5;
	}
`;

const ImageElement = styled.img`
	pointer-events: none;
`;

const functionByType = {
	[PlayerImageType.headshot]: getPlayerAvatar,
	[PlayerImageType.actionShotImage]: getPlayerActionShotImage,
	[PlayerImageType.actionFullImage]: getPlayerActionFullImage,
};

const imageAltText = {
	[PlayerImageType.headshot]: "player's headshot",
	[PlayerImageType.actionShotImage]: "player's action shot",
	[PlayerImageType.actionFullImage]: "player's action full",
};

interface IProps {
	type: PlayerImageType;
	player: IPlayer;
}

export const PlayerAvatar: React.FC<IProps> = ({type, player}) => {
	const [link, setLink] = useState<string | null>(null);
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const altText = `${player.firstName} ${player.lastName} - ${imageAltText[type]}`;

	useEffect(() => {
		void functionByType[type](player)
			.then((url) => {
				setLink(url);
			})
			.finally(() => {
				setIsLoading(false);
			});
	}, [player, type]);

	if (isLoading) {
		return (
			<Position>
				<CircularProgress />
			</Position>
		);
	}

	if (!link) {
		return null;
	}

	return <ImageElement className={"player-image"} src={link} alt={altText} loading={"lazy"} />;
};
